/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const teaserSloganStyle = {
  teaserSlogan: {
    maxHeight: "50vh",
    backgroundPosition: "top center",
    backgroundSize: "cover",
    borderRadius: { xs: "auto", sm: "25px 25px 0 0" },
  },
  sloganContainer: {
    backgroundColor: "rgba(255,255,255,0.7)",
    paddingTop: "1rem",
    paddingBottom: "1rem",
  },
  slogan: {
    textAlign: "center",
    fontWeight: 400,
    margin: 0,
    padding: 0,
    fontSize: "2rem",
  },
};

export default teaserSloganStyle;
